import { debounce } from 'lodash';
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactTable from "react-table";
import { Button, Card, CardBody, Input, Row } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import DataTablePagination from "../../../components/DatatablePagination";
import { ORDER_COLLECTION } from "../../../config/env";
import { firestore } from "../../../helpers/Firebase";
import { accessTypes, CalculatePoints, createNotification } from "../../../helpers/Utils";
import Customer from "./components/Customer";



const Customers = () => {
  const { user } = useSelector(state => state.authUser)
  const [allUsers, setAllUsers] = useState([])
  const [filteredUsers, setFilteredUsers] = useState([])
  const [lastVisible, setLastVisible] = useState(false)
  const [search, setSearch] = useState(false)
  const [loading, setLoading] = useState(true)
  const [selectedCustomer, setSelectedCustomer] = useState(false)

  const dataTableColumns = () => [
    {
      Header: "Name",
      accessor: "name",
      Cell: props => <p className="list-item-heading">{props.value}<br />{props.original.number || 'N/A'}</p>
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: props => <p className="list-item-heading">{props.value || 'N/A'}</p>
    },
    // {
    //   Header: "Phone Number",
    //   accessor: "number",
    //   Cell: props => <p className="list-item-heading">{props.value}</p>
    // },

    {
      Header: "Orders Placed",
      accessor: "ordersPlaced",
      Cell: props => <p className="list-item-heading">{props.value}</p>
    },
    {
      Header: "First Order At",
      accessor: "firstOrder",
      Cell: props => <div className="list-item-heading" >{moment(props.value).format("DD/MM/YYYY")}<div style={{ fontSize: '10px' }}>{moment(props.value).format("hh:mmA")}</div></div>
    },
    {
      Header: "Last Order At",
      accessor: "lastOrder",
      Cell: props => <div className="list-item-heading" >{moment(props?.value || '').format("DD/MM/YYYY")}<div style={{ fontSize: '10px' }}>{moment(props?.value || '').format("hh:mmA")}</div></div>
    },
    {
      Header: "Total Revenue",
      accessor: "revenue",
      Cell: props => <p className="list-item-heading">{"AED " + (props?.value)?.toFixed(2)}</p>
    },
    {
      Header: "Wallet Total",
      accessor: "walletTotal",
      Cell: props => <p className="list-item-heading">{"AED " + (props?.value || 0)?.toFixed(2)}</p>
    },
    {
      Header: "Total Credit",
      accessor: "walletCredit",
      Cell: props => <p className="list-item-heading">{"AED " + (props?.value || 0)?.toFixed(2)}</p>
    },
    {
      Header: "Total Cashback",
      accessor: "walletCashback",
      Cell: props => <p className="list-item-heading">{"AED " + (props?.value || 0)?.toFixed(2)}</p>
    },
    {
      Header: "Total Vouchers",
      accessor: "walletVouchers",
      Cell: props => <p className="list-item-heading">{"AED " + (props?.value || 0)?.toFixed(2)}</p>
    },

  ];

  const getUsers = async (type, number) => {
    let ref = firestore().collection('users')
    setLoading(true)
    console.log('type', type);
    console.log('number', number);

    switch (type) {
      case 'loadmore':
        ref = ref.orderBy("created_date", "desc").startAfter(lastVisible)

        break;
      case 'number':
        let searchQuery = Number(number)
        searchQuery = String(searchQuery).replace(/\s/g, '');

        if (String(searchQuery).startsWith("971")) {
          var temp = String(searchQuery).substring(3, String(searchQuery).length);
          searchQuery = temp;
        }
        ref = ref.where('number', '>=', String(searchQuery)).where('number', '<=', String(searchQuery) + '\uf8ff')
          .orderBy('number')
        break;
      case 'email':
        let emailQuery = String(number).toLowerCase().trim();
        ref = ref.where('email', '>=', emailQuery).where('email', '<=', emailQuery + '\uf8ff')
          .orderBy('email')
        break;

      default:
        ref = ref.orderBy("created_date", "desc")

        break;
    }
    let snap = await ref.limit(100).get()
    let data = await Promise.all(snap?.docs?.map(async res => {
      let ref = firestore().collection(ORDER_COLLECTION)
      if (!accessTypes.includes(user?.accessType)) {
        ref = ref.where("sp_id", "==", user?.uid)
      }
      let userNumber = Number(res.data().number)

      let userBookingsSnap = await ref.where('customer_number', '==', String(userNumber)).get()
      let userBookingsSnap2 = await ref.where('customer_number', '==', String("0" + Number(userNumber))).get()

      let userBookings = [...userBookingsSnap.docs, ...userBookingsSnap2.docs].map(r => { return { ...r.data(), key: r.id } }) || []
      let createdArray = userBookings.map(r => r.created)
      let totalRevenue = userBookings?.map(r => (r?.totalPrice && r?.status !== 'canceled' && r?.status !== 'rejected' ? (r?.totalPrice * 1) : 0))?.reduce((a, b) => a + b, 0)
      
      // Retrieve wallet log data
      let customerWalletSnap = await firestore().collection('users').doc(res.id).collection('walletLog').get()
      let walletLog = customerWalletSnap.docs.map(rec => {
        return { ...rec.data(), id: rec.id }
      })
      walletLog = walletLog?.sort((a, b) => b.created - a.created)?.filter(t => !t?.voided) || []
      
      // Calculate wallet summaries
      const walletSummary = CalculatePoints(walletLog)
      
      if (res.exists && !userBookingsSnap.empty) {
        return {
          ...res.data(),
          id: res.id,
          key: res.id,
          ordersPlaced: createdArray.length,
          firstOrder: createdArray.length ? Math.min.apply(null, createdArray) : new Date().getTime(),
          lastOrder: createdArray.length ? Math.max.apply(null, createdArray) : new Date().getTime(),
          revenue: totalRevenue,
          number: res.data().phoneNumber,
          orders: userBookings,
          walletLog: walletLog,
          walletTotal: walletSummary.total || 0,
          walletCredit: walletSummary.totalCredit || 0,
          walletCashback: walletSummary.totalCashback || 0,
          walletVouchers: walletSummary.totalVouchers || 0
        }
      }
      return false

    }))
    const last = snap.docs[snap.docs.length - 1];
    setLastVisible(last)
    if (number) {
      let allUsers = data?.filter(rec => rec)
      setFilteredUsers(allUsers)
      setAllUsers(allUsers)
    } else {
      let allUsers = filteredUsers?.concat(data)?.filter(rec => rec)
      setFilteredUsers(allUsers)
      setAllUsers(allUsers)
    }
    setLoading(false)
  }


  useEffect(() => {
    async function fetchData() {
      await getUsers()
    }
    fetchData();
    // eslint-disable-next-line
  }, [])


  var debounce_fun = debounce(async function (e) {
    setFilteredUsers([])
    setAllUsers([])
    setSearch({ ...search, number: e })
    if (e.length) {
      await getUsers('number', e)
    } else {
      await getUsers()
    }
  }, 1000);

  var debounce_email = debounce(async function (e) {
    setFilteredUsers([])
    setAllUsers([])
    setSearch({ ...search, email: e })
    if (e.length) {
      await getUsers('email', e)
    } else {
      await getUsers()
    }
  }, 1000);

  const exportCustomersCSV = () => {
    if (!filteredUsers || filteredUsers.length === 0) {
      createNotification('warning', 'No customer data to export', 'Export Failed')
      return
    }

    const csvRows = []
    
    // Define comprehensive CSV headers
    const headers = [
      'Customer Name',
      'Customer Phone',
      'Customer Email',
      'Customer Address',
      'Total Orders',
      'First Order Date',
      'Last Order Date',
      'Total Revenue (AED)',
      'Wallet Total (AED)',
      'Wallet Credit (AED)',
      'Wallet Cashback (AED)',
      'Wallet Vouchers (AED)',
      'Most Ordered Service',
      'Most Ordered Service Count',
      'Completed Orders',
      'Canceled Orders',
      'Average Order Value (AED)',
      'Last Order Status'
    ]
    
    csvRows.push(headers.join(','))

    // Helper function to sanitize CSV fields
    const sanitizeField = (field) => {
      if (field === null || field === undefined || field === '') return '--'
      const str = String(field)
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
        return `"${str.replace(/"/g, '""')}"`
      }
      return str
    }

    // Process each customer
    for (const customer of filteredUsers) {
      // Calculate most ordered service
      let serviceCounts = {}
      let mostOrderedService = '--'
      let mostOrderedServiceCount = 0
      
      if (customer.orders && customer.orders.length > 0) {
        customer.orders.forEach(order => {
          const serviceName = order.service_name || 'Unknown'
          serviceCounts[serviceName] = (serviceCounts[serviceName] || 0) + 1
        })
        
        // Find the service with max count
        let maxCount = 0
        Object.entries(serviceCounts).forEach(([service, count]) => {
          if (count > maxCount) {
            maxCount = count
            mostOrderedService = service
            mostOrderedServiceCount = count
          }
        })
      }

      // Calculate completed and canceled orders
      const completedOrders = customer.orders?.filter(o => 
        o.status === 'completed' || o.status === 'rated' || o.status === 'notRated'
      ).length || 0
      
      const canceledOrders = customer.orders?.filter(o => 
        o.status === 'canceled' || o.status === 'cancelled' || o.status === 'rejected'
      ).length || 0

      // Calculate average order value
      const avgOrderValue = customer.ordersPlaced > 0 
        ? (customer.revenue / customer.ordersPlaced).toFixed(2) 
        : '0.00'

      // Get last order status
      const lastOrderStatus = customer.orders && customer.orders.length > 0
        ? customer.orders.sort((a, b) => b.created - a.created)[0]?.status || '--'
        : '--'

      // Get customer address from their profile or most recent order
      let customerAddress = '--'
      if (customer.address) {
        customerAddress = customer.address
      } else if (customer.orders && customer.orders.length > 0) {
        // Get address from most recent order
        const sortedOrders = [...customer.orders].sort((a, b) => b.created - a.created)
        const lastOrderWithAddress = sortedOrders.find(o => o.place?.address)
        if (lastOrderWithAddress) {
          customerAddress = lastOrderWithAddress.place.address
        }
      }

      const row = [
        sanitizeField(customer.name || '--'),
        sanitizeField(customer.number || customer.phoneNumber || '--'),
        sanitizeField(customer.email || '--'),
        sanitizeField(customerAddress),
        customer.ordersPlaced || 0,
        customer.firstOrder ? moment(customer.firstOrder).format('DD/MM/YYYY HH:mm') : '--',
        customer.lastOrder ? moment(customer.lastOrder).format('DD/MM/YYYY HH:mm') : '--',
        (customer.revenue || 0).toFixed(2),
        (customer.walletTotal || 0).toFixed(2),
        (customer.walletCredit || 0).toFixed(2),
        (customer.walletCashback || 0).toFixed(2),
        (customer.walletVouchers || 0).toFixed(2),
        sanitizeField(mostOrderedService),
        mostOrderedServiceCount,
        completedOrders,
        canceledOrders,
        avgOrderValue,
        sanitizeField(lastOrderStatus)
      ]
      
      csvRows.push(row.join(','))
    }

    // Combine all rows into a single CSV string
    const csvString = csvRows.join('\n')

    // Create a download link for the CSV file
    const link = document.createElement('a')
    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString)
    link.download = `customers_export_${moment().format('YYYY-MM-DD_HH-mm')}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    createNotification('success', `Exported ${filteredUsers.length} customers successfully`, 'Export Complete')
  }

  useEffect(() => {
    let filtered = allUsers?.filter(item => {
      return (
        (search?.name?.length ? String(item.name).toLowerCase().includes(search?.name?.toLowerCase()) : true)
      )
    })
    setFilteredUsers(filtered)
  }, [search?.name, allUsers])
  return (
    <Fragment>
      {(loading) &&
        <div className='loading'></div>
      }
      <Row>
        <Colxx xxs="12">
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <h1 className="mb-2 p-0">Customers</h1>
            <Button
              color="primary"
              size="sm"
              onClick={exportCustomersCSV}
              disabled={!filteredUsers || filteredUsers.length === 0 || loading}
              style={{ whiteSpace: 'nowrap' }}
            >
              <i className="simple-icon-cloud-download mr-1" />
              Export Customers
            </Button>
          </div>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <Card className="mb-4 rounded">
            <CardBody>
              <Row>
              
                <Colxx xxs="12" md="4" className='mt-1'>
                  <Input type="text" style={{ borderRadius: '4px' }} placeholder="Customer Name" name="name" onChange={(e) => {
                    setSearch({ ...search, name: e.target.value })
                  }} />
                </Colxx>
                <Colxx xxs="12" md="4" className='mt-1'>
                  <Input type="number" style={{ borderRadius: '4px' }} placeholder="Mobile Number" name="number" onChange={(e) => {
                    debounce_fun(e.target.value)
                  }} />
                </Colxx>
                <Colxx xxs="12" md="4" className='mt-1'>
                  <Input type="email" style={{ borderRadius: '4px' }} placeholder="Email Address" name="email" onChange={(e) => {
                    debounce_email(e.target.value)
                  }} />
                </Colxx>
              </Row>

            </CardBody>
          </Card>
        </Colxx>
        <Colxx xxs="12">
          <Card className="mb-4 rounded">
            <CardBody>
              {filteredUsers || allUsers ? <ReactTable
                data={filteredUsers ? filteredUsers : allUsers}
                showPageJump={false}
                defaultPageSize={10}
                columns={dataTableColumns()}
                onPageChange={async (page) => {
                  let pageCount = Math.ceil(filteredUsers?.length / 10)
                  if ((page + 1) === pageCount && !search?.number && !search?.email) {
                    await getUsers('loadmore')
                  }
                }
                }
                getTrGroupProps={(state, rowInfo, column, instance) => {
                  return {
                    onClick: e => {
                      if (rowInfo?.original) {
                        setSelectedCustomer(rowInfo.original)
                      } else {
                        setSelectedCustomer(null)
                      }
                    },

                  }
                }}
                PaginationComponent={DataTablePagination}
                showPageSizeOptions={false}
              /> : <div className="d-flex flex-row mb-3 pb-3 text-center justify-content-center ">
                <div className='font-weight-bold'>No Customers yet!</div>
              </div>}
            </CardBody>
          </Card>
        </Colxx>
        {selectedCustomer && <Customer
          customer={selectedCustomer}
          dismiss={() => setSelectedCustomer(false)}
        />
        }
      </Row>
    </Fragment>
  );
};

export default Customers;
